const DOCUMENT_TYPE_MAP: Record<string, string> = {
  "application/pdf": "PDF Document",

  // Microsoft Office Documents
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "Word Document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "Excel Spreadsheet",
  "application/msword": "Word Document",
  "application/vnd.ms-excel": "Excel Spreadsheet",
  "application/octet-stream": "E-mail",

  // Text Files
  "text/plain": "Text File",
  "text/csv": "CSV File",

  // Images
  "image/jpeg": "JPEG Image",
  "image/png": "PNG Image",

  // JSON
  'application/json': 'JSON File',
};

export function getFriendlyDocumentType(mimeType: string): string {
  return DOCUMENT_TYPE_MAP[mimeType] || mimeType;
}
